module.exports = __webpack_public_path__ + "static/media/9.ab8e45aa.PNG";